module.exports = __webpack_public_path__ + "static/media/app-1.ade0f7da.jpg";